<template>
  <div class="spinner-wrap" v-if="loading">
    <div class="skeleton-wrapper">
      <div class="skeleton-image"></div>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
	name: 'SpinnerChart',
  data() {
    return {
      loading: false
    }
  },

	watch: {
		loading: function () {
		}
	},
  methods: {
    showLoading(val) {
      this.loading = val;
    }
  },
}
</script>

<style scoped>

.spinner-wrap {
  position: relative;
  z-index: 5;
  width: 100%;
  height: 100%;
}
.skeleton-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.skeleton-image {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #e0e0e0;
}

@keyframes shimmer {
  0% {
    background-position: 100%;
  }
  100% {
    background-position: -100%;
  }
}

.skeleton-image,
.skeleton-text {
  background: linear-gradient(
    90deg,
    #e0e0e0 25%,
    #f5f5f5 50%,
    #e0e0e0 75%
  );
  background-size: 200% 100%;
}

.skeleton-text.short {
  width: 60%;
}
.spinner {
  width: 11.2px;
  height: 11.2px;
  border-radius: 11.2px;
  box-shadow: 28px 0px 0 0 rgba(90,87,170,0.2), 22.7px 16.5px 0 0 rgba(90,87,170,0.4), 8.68px 26.6px 0 0 rgba(90,87,170,0.6), -8.68px 26.6px 0 0 rgba(90,87,170,0.8), -22.7px 16.5px 0 0 #5a57aa;
  animation: spinner-b87k6z 1s infinite linear;
}
@keyframes spinner-b87k6z {
  to {
    transform: rotate(360deg);
  }
}
</style>
